import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import axios from "axios";
import swal from "sweetalert";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import Widget from "../../components/Widget/Widget";
import { API_TIMEOUT, NIRLABA_PROGRAM } from "../../utils/index";
import {
  filterRowsByMitraLembaga,
  getMitraQueryParams,
} from "../../utils/adminMitra";
import { numberWithCommas } from "../../utils/func";

const { SearchBar } = Search;
const currentYear = new Date().getFullYear();
const listTahun = Array.from({ length: currentYear - 2018 + 1 }, (_, i) =>
  String(2018 + i)
).reverse();

const ProgramNirlabaList = () => {
  const dispatch = useDispatch();
  const [tahun, setTahun] = useState(String(currentYear));
  const [rows, setRows] = useState([]);
  const [idHapus, setIdHapus] = useState();
  const [modalDelete, setModalDelete] = useState(false);

  const load = (th) => {
    axios
      .get(NIRLABA_PROGRAM, {
        params: { tahun: th, ...getMitraQueryParams() },
        timeout: API_TIMEOUT,
      })
      .then((res) => {
        const data = filterRowsByMitraLembaga(res.data?.data || []);
        setRows(data.map((item, i) => ({ ...item, nomor: i + 1 })));
      })
      .catch((err) => alert(err));
  };

  useEffect(() => {
    load(tahun);
  }, [tahun]);

  const hapus = () => {
    axios
      .delete(NIRLABA_PROGRAM + "/" + idHapus, { timeout: API_TIMEOUT })
      .then((res) => {
        if (res.data?.success === 1) {
          swal("Sukses", "Program tahun dihapus", "success");
          setModalDelete(false);
          load(tahun);
        }
      })
      .catch((err) => alert(err));
  };

  const columns = [
    { dataField: "nomor", text: "No.", sort: true },
    { dataField: "nama_lembaga", text: "Lembaga", sort: true },
    { dataField: "bantuan", text: "Program", sort: true },
    { dataField: "tahun", text: "Tahun" },
    {
      dataField: "total_dana",
      text: "Total dana",
      formatter: (cell) => "Rp " + numberWithCommas(cell || 0),
    },
    { dataField: "jml_penerima", text: "Kuota" },
    {
      dataField: "id",
      text: "Aksi",
      formatter: (cell, row) => (
        <div>
          <Button
            color="info"
            size="xs"
            className="mr-2"
            onClick={() => {
              const q = new URLSearchParams({
                tahun: String(row.tahun || tahun),
                bantuan: row.bantuan || "",
              });
              if (row.id_lembaga) q.set("id_lembaga", String(row.id_lembaga));
              dispatch(push(`/admin/nirlaba/bantuan-detail?${q.toString()}`));
            }}
          >
            Detail
          </Button>
          <Button
            color="success"
            size="xs"
            className="mr-2"
            onClick={() => dispatch(push(`/admin/nirlaba/program/${cell}/edit`))}
          >
            Edit
          </Button>
          <Button
            color="danger"
            size="xs"
            onClick={() => {
              setIdHapus(cell);
              setModalDelete(true);
            }}
          >
            Hapus
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-top-line">
        <h2 className="page-title">
          Program mitra <span className="fw-semi-bold">per tahun</span>
        </h2>
      </div>
      <Widget>
        <ToolkitProvider keyField="id" data={rows} columns={columns} search>
          {(props) => (
            <div>
              <div className="d-flex justify-content-between mb-3 flex-wrap">
                <div className="d-flex align-items-center mb-2">
                  <SearchBar {...props.searchProps} />
                  <Input
                    type="select"
                    className="ml-2"
                    style={{ width: 120 }}
                    value={tahun}
                    onChange={(e) => setTahun(e.target.value)}
                  >
                    {listTahun.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </Input>
                </div>
                <Button
                  color="primary"
                  onClick={() => dispatch(push("/admin/nirlaba/program/new"))}
                >
                  Input program tahun
                </Button>
              </div>
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory()}
                bootstrap4
              />
            </div>
          )}
        </ToolkitProvider>
      </Widget>
      <Modal isOpen={modalDelete} toggle={() => setModalDelete(false)}>
        <ModalHeader>Hapus program tahun</ModalHeader>
        <ModalBody>Yakin menghapus data ini?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalDelete(false)}>
            Batal
          </Button>
          <Button color="danger" onClick={hapus}>
            Hapus
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ProgramNirlabaList;
